import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { KeyRound, Files, Eye, CheckCircle2 } from "lucide-react";

function StatCard({ label, value, icon: Icon, testid }) {
  return (
    <div
      data-testid={testid}
      className="rounded-lg p-6 border transition-colors hover:border-white/20"
      style={{ background: "var(--vault-surface)", borderColor: "var(--vault-border)" }}
    >
      <div className="flex items-center justify-between mb-4">
        <p className="overline text-[var(--vault-text-muted)]">{label}</p>
        <Icon className="w-4 h-4" style={{ color: "var(--vault-gold)" }} />
      </div>
      <p className="font-display text-4xl tracking-tight">{value}</p>
    </div>
  );
}

export default function AdminOverview() {
  const [stats, setStats] = useState({ total_codes: 0, active_codes: 0, total_files: 0, total_accesses: 0 });

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview" className="space-y-10">
      <header>
        <p className="overline text-[var(--vault-text-muted)] mb-2">Dashboard</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight">Overview</h1>
        <p className="text-[var(--vault-text-muted)] mt-3 max-w-xl">
          Monitor your cellar at a glance — codes issued, certificates stored and the times someone has uncorked a bottle.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard label="Total Codes" value={stats.total_codes} icon={KeyRound} testid="stat-total-codes" />
        <StatCard label="Active Codes" value={stats.active_codes} icon={CheckCircle2} testid="stat-active-codes" />
        <StatCard label="Files Stored" value={stats.total_files} icon={Files} testid="stat-total-files" />
        <StatCard label="Total Accesses" value={stats.total_accesses} icon={Eye} testid="stat-total-accesses" />
      </div>

      <section
        className="rounded-lg p-8 border"
        style={{ background: "var(--vault-surface)", borderColor: "var(--vault-border)" }}
      >
        <h2 className="font-display text-2xl mb-4">Quick start</h2>
        <ol className="space-y-3 text-[var(--vault-text-muted)] list-decimal list-inside">
          <li>Upload a certificate or tasting note in <span className="text-white">Files</span>.</li>
          <li>Create a code in <span className="text-white">Access Codes</span> and link it to your bottle.</li>
          <li>Print or attach the code to the bottle — the buyer enters it on verifinewines.com to authenticate.</li>
        </ol>
      </section>
    </div>
  );
}
